import { render } from "./orderHistory.vue?vue&type=template&id=1ab79db8&scoped=true"
import script from "./orderHistory.vue?vue&type=script&lang=js"
export * from "./orderHistory.vue?vue&type=script&lang=js"

import "./orderHistory.vue?vue&type=style&index=0&id=1ab79db8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab79db8"]])

export default __exports__